<template>
    <div class="rsy-item">
        <p class="webm_ios" v-if="videos.length > 0 && isIOS">{{$t('lang.report.rsy-ads.webm_ios')}}</p>
        <div class="rsy-item__layout" style="filter: none; opacity: 1" :style="{'background-image': 'url(' + getImageUrl(images[0]) + ')'}" v-if="!isImage(files[0])"></div>
        <div class="rsy-item__layout" :style="{'background-image': 'url(' + getImageUrl(images[0]) + ')'}" v-else></div>

        <a v-if="!disableFancy" :data-fancybox="adId" :href="getImageUrl(video)" data-width="640" data-height="360" v-for="video in videos">
            <div class="rsy-item__video" style="opacity: 0.4;">

                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M19.5 39.5C19.3006 39.4989 19.1035 39.4582 18.92 39.38C18.6464 39.2682 18.4125 39.0769 18.2486 38.831C18.0846 38.585 17.998 38.2956 18 38V10C18.0109 9.71537 18.1025 9.43971 18.2643 9.20526C18.426 8.97081 18.6512 8.78726 18.9134 8.67607C19.1756 8.56488 19.4641 8.53066 19.7451 8.57739C20.0261 8.62413 20.2879 8.7499 20.5 8.94L34.5 22.94C34.7809 23.2213 34.9387 23.6025 34.9387 24C34.9387 24.3975 34.7809 24.7787 34.5 25.06L20.5 39.06C20.2317 39.324 19.8759 39.4805 19.5 39.5ZM21 13.62V34.38L31.38 24L21 13.62Z"
                        fill="white"/>
                </svg>

            </div>
        </a>
        <a v-else :href="getImageUrl(video)" data-width="640" data-height="360" v-for="video in videos">
            <div class="rsy-item__video" style="opacity: 0.4;">

                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M19.5 39.5C19.3006 39.4989 19.1035 39.4582 18.92 39.38C18.6464 39.2682 18.4125 39.0769 18.2486 38.831C18.0846 38.585 17.998 38.2956 18 38V10C18.0109 9.71537 18.1025 9.43971 18.2643 9.20526C18.426 8.97081 18.6512 8.78726 18.9134 8.67607C19.1756 8.56488 19.4641 8.53066 19.7451 8.57739C20.0261 8.62413 20.2879 8.7499 20.5 8.94L34.5 22.94C34.7809 23.2213 34.9387 23.6025 34.9387 24C34.9387 24.3975 34.7809 24.7787 34.5 25.06L20.5 39.06C20.2317 39.324 19.8759 39.4805 19.5 39.5ZM21 13.62V34.38L31.38 24L21 13.62Z"
                        fill="white"/>
                </svg>

            </div>
        </a>

        <a v-if="!disableFancy" :data-fancybox="adId" class="rsy-item__link" :data-src="getImageUrl(img)" v-for="img in images">
            <img :src="getImageUrl(img)" class="rsy-item__image" alt=""/>
        </a>
        <a v-else class="rsy-item__link" :data-src="getImageUrl(img)" v-for="img in images">
            <img :src="getImageUrl(img)" class="rsy-item__image" alt=""/>
        </a>

        <div class="badge" v-if="childCount > 1" v-on:click="$emitter.emit(Listeners.RSYA_POPUP_GROUPING_OPEN, adId)">{{ $t('lang.report.rsy-ads.child_count', [this.childCount]) }}</div>
    </div>
</template>

<script>
import S3storage from "../../mixins/S3storage";
import {Listeners} from "../../constants/listeners";

export default {

    name: "RsyAdImgContainer",
    mixins: [S3storage],
    props: {
        adId: {
            type: String,
            required: true
        },
        files: {
            type: Array,
            required: true
        },
        childCount: {
            type: Number,
            default: 0
        },
        disableFancy: {
            type:Boolean,
            default: false,
        }
    },
    computed: {
        Listeners() {
            return Listeners
        },

        videos() {
            return this.files.filter(f => !this.isImage(f))
        },
        images() {
            return this.files.filter(f => this.isImage(f))
        },
        isIOS() {
            return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
        }
    },
    methods: {
        isImage: (filename) => {
            return filename.includes('.gif') || filename.includes('.webp')
        }
    },
    mounted() {
    }
}
</script>

<style scoped>

.badge {
    cursor: pointer;
    z-index: 100;
    position: absolute;
    bottom: 3px;
    right: 3px;
    background-color: rgba(0, 0, 0, 0.5);
    color: #FFF;
    padding: 8px 12px 8px 12px;
    border: 1px solid #FFF;
    border-radius: 6px;
}

.webm_ios {
    position: absolute;
    z-index: 10;
    width: 100%;
    color: #fff;
    padding: 10px;
    background-color: #00000096;
}

.rsy-item {
    position: relative;
    overflow: hidden;
    border-radius: 5px;
    height: 200px;
}
.rsy-item a {
    position: relative;
    z-index: 2;
}
.rsy-item__video {
    width: 100%;
    height: 100%;
    background: black;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.rsy-item__layout {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    filter: blur(14px);
    z-index: 1;
    opacity: .9;
}

.rsy-item__link {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
}

.rsy-item__image {
    max-width: 100%;
    max-height: 100%;
}

</style>
